import styled from 'styled-components';
import { css } from 'styled-components';

import SvgIcon from '~src/shared/SvgIcon';
import { alignCenterMiddle } from '~src/styles/utils/positioning';

export const ImageWrapper = styled.div<{ $size: number }>`
  border-radius: 50%;
  height: ${({ $size }) => $size}px;
`;

export const AnonWrapper = styled.div<{ $size: number }>`
  background-color: ${({ theme }) => theme.baseBlue.a10};
  border-radius: 50%;
  height: ${({ $size }) => $size}px;
  width: ${({ $size }) => $size}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AnonIcon = styled(SvgIcon)`
  color: ${({ theme }) => theme.white.a10};
`;

export const ImageUrl = styled.img<{ $size: number; $borderColor?: string }>`
  background-color: ${({ theme }) => theme.lightBlue.a10};
  height: ${({ $size }) => $size}px;
  width: ${({ $size }) => $size}px;
  border-radius: 50%;
  overflow: hidden;
  vertical-align: baseline;
  ${({ $borderColor }) => $borderColor && `border: 2px solid ${$borderColor}`};
`;

export const LettersBox = styled.div<{ $size?: number; $typeIsUser?: boolean; $borderColor?: string }>(
  ({ theme, $size, $typeIsUser, $borderColor }) => css`
    color: ${theme.white.a10};
    background-color: ${theme.lightBlue.a10};
    width: ${$size}px;
    height: ${$size}px;
    border-radius: 50%;
    font-weight: 400;
    ${$size && `font-size: ${$typeIsUser ? $size / 2.2 : $size / 1.8}px`};
    ${$size && `line-height: ${$borderColor ? $size - 5 : $size - 1}px`};
    text-align: center;
    text-decoration: none;
    position: relative;
    ${$borderColor && `border: 2px solid ${$borderColor}`};

    .subject-icon {
      color: ${theme.white.a10};
      ${alignCenterMiddle}
    }
  `,
);
